import './OfferInformation.less';

const OfferInformation = (() =>{

})();

export default OfferInformation;